import styled from "@emotion/styled";

import { Div } from "~/components/content/content-schema-render/div";

export const ArticleLeadingVideoContainer = styled.div`
  ${props => props.theme.breakpoints.only("mobile")} {
    display: flex;
    align-items: center;

    block-size: 100vw;

    background-color: #f0f0f0;

    /* NOTE: Need to control the inline-size of Div component which is the direct child,
             would rather apply it here than to all Div */
    > ${Div} {
      inline-size: 100%;
    }
  }
`;
